<template>
	<VDialogV3
		class="vehicle-card"
		position="right"
		width="600px"
		height="100vh"
    :entity="localVehicle"
		:loading="!localVehicle"
    :context-menu="VehiclesService.contextMenu"
		@submit-button:clicked="onSubmit"
	>
			<section>
				<VInput
					ref="nameInput"
					v-model="localVehicle.name"
					label="Название"
					layout="vertical"
					required
					:max-length="200"
				/>

        <VSelectV2
          v-model="localVehicle.vehicleType"
          :data="vehicleTypesSource"
          label="Тип транспорта"
          layout="vertical"
          placeholder="Выберите тип"
          required
          :clearable="false"
        />

				<VFormItem class="weight-row">
					<VInputNumberRusV2
						v-model="localVehicle.maxWeight"
            :type="Weight"
						class="weight"
						label="Грузоподъёмность"
						layout="vertical"
						placeholder="Например: 20000"
						:min="0"
            unit="кг"
					/>
				</VFormItem>

				<VInputNumberRusV2
					v-model="localVehicle.maxVolume"
					label="Объём кузова"
					layout="vertical"
					placeholder="Например: 60"
					:min="0"
          unit="м³"
          :type="Volume"
				/>

				<VTemperatureRangeInput
					v-model="localVehicle.temperatureRange"
				/>
        <VInputNumber
          :min="0"
          :max="9999"
          v-model="localVehicle.cargoPlacesCount"
          label="Количество мест по полу">
        </VInputNumber>

			</section>
	</VDialogV3>
</template>

<script lang="ts">

import VehicleType         from '@/domains/VehicleTypes/VehicleType';
import VehicleTypesService from '@/domains/VehicleTypes/VehicleTypesService';
import Vehicle             from '@/domains/Vehicles/Vehicle';
import VehiclesService     from '@/domains/Vehicles/VehiclesService';
import Weight              from '@/core/types/Weight';
import Volume              from '@/core/types/Volume'

export default defineComponent({
	name: 'VehicleCard',

	props: {
		vehicle: {
			type:    Vehicle,
			default: null,
		},
		defaultVehicleType: {
			type:    VehicleType,
			default: null,
		},
	},

  setup() {
    return {
      Volume,
      Weight,
      VehiclesService
    };
  },

  data() {
		return {

			localVehicle: null as Vehicle | null,

      vehicleTypesSource: this.$core.loader.select(
        () => VehicleTypesService.getList().then(r => r.data),
      ).preloadOnMount(),
		};
	},

	computed: {
		isEditMode() {
			return this.localVehicle?.isExisting;
		},
	},

	created() {
		this.init();
	},

	methods: {
		async init(): Promise<void> {
			const vehicle = this.vehicle
				? this.$core.utils.cloneDeep(this.vehicle)
				: Vehicle.fromNew();

      if (!vehicle.id && this.defaultVehicleType) {
        vehicle.vehicleType = this.defaultVehicleType;
      }

			this.localVehicle = vehicle;
		},

		async onSubmit(): Promise<void> {

      if (!this.localVehicle) return;

      const success = this.isEditMode
        ? await VehiclesService.update(this.localVehicle)
        : await VehiclesService.add(this.localVehicle);

      if (success) {
        this.$core.dialogs.VehicleCard.resolve();
      }
		},
	},
});
</script>
